import InstagramPostGrid from './InstagramPostGrid.vue'
export default InstagramPostGrid
